import { Directive, HostListener, Input } from '@angular/core';

/**
 * A directive to prevent characters that aren't allowed based on regex
 * 
 * example:
 * <input [inputRegex]="<regex-string>" />
 */
@Directive({
    selector: '[inputRegex]',
})
export class InputRegexDirective {
    @Input('inputRegex') regex: RegExp;

    @HostListener('keypress', ['$event']) onKeyPress(e): void {
        const expr = new RegExp(this.regex);

        if (!expr.test(e.key) && e.charCode != 13) {
            e.preventDefault();
        }
    }
}